import React from 'react';
import styled from 'styled-components/macro';
import ScrollableAnchor from 'react-scrollable-anchor';
import {
  Heading1,
  Heading2,
  Paragraph,
  LinkStyled,
  Bold,
} from '../../components/typography';
import {
  Container,
  Row,
  Col,
} from '../../components/grid';
import { Image, ImagePopup } from '../../components/Image';
import SidemenuLayout from '../../layout/DefaultLayout/Layouts/SidemenuLayout';
import { Item } from '../../containers/commerce';
import ProductViewKulsyre from '../../components/commerce/ProductViews/ProductViewKulsyre';
import { Content } from './Kulsyre';

export const Grid = styled.div`
  display: grid;
  grid-gap: 30px;
  grid-template-columns: repeat(2, 1fr);
  margin: 15px 0;

  @media (max-width: 1199px) {
    grid-template-columns: 1fr;
  }

  @media (max-width: 1199px) {
    grid-gap: 15px;
    margin: 0;
  }
`;

export default () => (
  <SidemenuLayout menuPicker="Kulsyre" activeSidemenu="KulsyreFadoel">
    <Container white mb>
      <Row>
        <Col xs={12} id="salg-af-kulsyre" paddingBottom="0px">
          <Heading1 margin="0 0 10px">Kulsyre til fadøl</Heading1>
        </Col>
        <Col xs={12} paddingTop="0px" paddingBottom="0px">
          <Paragraph>
            Kulsyre til fadøl er det, der giver den friske og perlende fornemmelse på tungen og i munden, når du nyder et iskoldt glas frisk skænket fadøl. De fleste fustager indeholder ikke <LinkStyled to="/kulsyre">kulsyre</LinkStyled> i forvejen og det er derfor nødvendigt at tilkøbe en eller flere kulsyreflasker, så den rette følelse kan opnås.
          </Paragraph>
          <Paragraph>
            Det er den normale gæringsproces, der giver øllet sine karakteristiske små bobler. Hvis øllet får lov til at stå længe, forsvinder denne boblende fornemmelse. Derfor anvendes der især kulsyre til fadøl, så man er sikker på, at den rette smag og oplevelse opnås.
          </Paragraph>
          <Paragraph>
            <Bold>Kulsyreflasker i flere størrelser</Bold><br />
            Hos Skafte forhandler vi to forskellige størrelser af flasker med kulsyre til flasker.
            Selvom der ikke synes meget stor forskel på de to størrelser, så kan det bestemt være aktuelt, at vælge den helt rette størrelse, der passer til det forventede forbrug af kulsyreflasker.
          </Paragraph>
        </Col>
      </Row>
    </Container>
    <Container mb>
      <Row>
        <Col xs={12} padding="0">
          <Grid>
            <Content product>
              <Item varenr="8940" display={ProductViewKulsyre} />
            </Content>
            <Content product>
              <Item varenr="8944" display={ProductViewKulsyre} />
            </Content>
          </Grid>
        </Col>
      </Row>
    </Container>
    <Container white mb>
      <Row>
        <Col xs={3}>
          <Row>
            <Col xs={12} sm={12} md={6}>
              <Image name="kulsyre.kulsyre-fastlaast-trykregulator.jpg" alt="CO2 flaske med fastlåst trykregulator" title="CO2 flaske med fastlåst trykregulator" />
              <Paragraph fontSize="12px">Fast indstillet</Paragraph>
            </Col>
            <Col xs={12} sm={12} md={6}>
              <Image name="kulsyre.kulsyre-automatisk-trykregulator.jpg" alt="Kulsyreflaske med automatisk trykregulator" title="Kulsyreflaske med automatisk trykregulator" />
              <Paragraph fontSize="12px">Fast indstillet</Paragraph>
            </Col>
          </Row>
          <Row>
            <Col xs={12} sm={12} md={6}>
              <Image name="kulsyre.kulsyre-justerbar-trykregulator-defekt-manometer.jpg" alt="CO2 flaske med justerbar trykregulator og udgangstryk manometer defekt" title="CO2 flaske med justerbar trykregulator og udgangstryk manometer defekt" />
              <Paragraph fontSize="12px">Justerbar</Paragraph>
            </Col>
            <Col xs={12} sm={12} md={6}>
              <Image name="kulsyre.kulsyre-uden-regulator-hoejtryksslange.jpg" alt="Kulsyreflaske uden regulator, med højtryksslange" title="Kulsyreflaske uden regulator, med højtryksslange" />
              <Paragraph fontSize="12px">Højtryksslange</Paragraph>
            </Col>
          </Row>
          <Row>
            <Col xs={12} sm={12} md={6}>
              <Image name="kulsyre.kulsyre-justerbar-trykregulator-brugbart-manometer.jpg" alt="Kulsyreflaske med justerbar trykregulator og læsbart arbejdstryk manometer" title="Kulsyreflaske med justerbar trykregulator og læsbart arbejdstryk manometer" />
              <Paragraph fontSize="12px">
                Justerbar med brugbart manometer
              </Paragraph>
            </Col>
            <Col xs={12} sm={12} md={6}>
              <ImagePopup maxWidth="112.5px" imageWidth="112.5px" name="kulsyre.kulsyre-tomvaegt.jpg" />
              <Paragraph fontSize="12px">
                Halskrave med tomvægt
              </Paragraph>
            </Col>
          </Row>
        </Col>
        <Col xs={9}>
          <ScrollableAnchor id="kulsyre-hvor-meget">
            <div>
              <Heading2>Hvor meget kulsyre til fadøl?</Heading2>
              <Paragraph>
                Det er en god tommelfingerregel at regne med 250g kulsyre pr. fustage a 25l.<br />
                6 kg kulsyre rækker altså til mindst 24 fustager og ofte til over 30.<br />
                1 flaske blandingsgas rækker til ca. 8 fustager á 30 liter.
              </Paragraph>
              <Paragraph>
                Hvis du er i tvivl om der er nok i flasken, så vej den evt. på en badevægt og træk tomvægten fra.
                Tomvægten, eller tara, står sædvanligvis på en hvid plastik halskrans lige under ventilen.
                Hvis den mangler så regn med mellem 9 og 10 kg for en standard 6 kg flaske og mellem 7 og 8 kg for en 4 kg flaske.
              </Paragraph>
              <Heading2>Hvad skal trykket indstilles på, når der er tale om kulsyre til fadøl?</Heading2>
              <Paragraph>
                Trykket bør følge temperaturen.
                Hvis omgivelserne er 25 grader C skal trykket stilles på 2,5 bar hvis der er 30 grader C skal trykket være 3,0 bar og så fremdeles.
                Næsten alle vores fadølsanlæg er med fast indstillet trykregulator, og derfor uden et manometer der viser trykket. Her skal man slet ikke bekymre sig om kulsyretrykket.
                Ved problemer med for meget skum, er det sjældent kulsyretrykket den er gal med.
                Danskvandsanlæg arbejder med tryk på 5-6 bar.
              </Paragraph>
              <Paragraph>
                Det smarte ved, at næsten alle vores fadølsanlæg er udstyret med en trykregulator, er, at det er let for alle at skænke helt korrekt og læskende fadøl.
                Det er som sådan ikke en svær proces i sig selv, men dette er også fordi at udstyret ofte tager højde for de mange faldgruber, der kan opstå, fx at øllen skummer over eller at der slet ikke er brus i, når den er blevet skænket.
                Når du lejer er fadølsanlæg samt køber kulsyre fadøl her hos Skafte, kan du derfor være sikker på at få den bedst skænkede øl, der overhovedet er mulig.
                Sådan er nemlig både anlæg, kulsyreflasker og trykregulator med til at gøre oplevelsen lige god - hver gang.
              </Paragraph>
            </div>
          </ScrollableAnchor>
        </Col>
      </Row>
    </Container>
    <Container white>
      <Row>
        <Col xs={12}>
          <Heading2>Kulsyre til fadøl - perfekt til både privat og erhverv</Heading2>
          <Paragraph>
            Kulsyreflasker er en nødvendighed, når der skal skænkes velsmagende og brusende fadøl i glassene til festen, eventet, arrangementet eller begivenheden.
          </Paragraph>
          <Paragraph>
            Hvis du handler til erhverv, er det muligt at se prisen uden moms. Husk at leje en passende størrelse af et fadølsanlæg til festen i samme omgang, fx en klapbar, en vogn eller en stilladsbar.
          </Paragraph>
          <Paragraph>
            Hvis du bestiller til privatfesten, kan du vælge at bestille flasker med kulsyre til eget anlæg her hos Skafte. Du kan også aflevere en tom flaske tilbage i samme omgang, såfremt den matcher vores regler.
            Hvis du ikke er den heldige ejer af en fadølsanlæg derhjemme, kan du med fordel tage et kig på vores leje af anlæg og barer. Alle skal kunne få en iskold og velskænket fadøl.
          </Paragraph>
        </Col>
      </Row>
    </Container>
  </SidemenuLayout>
);
